import { RecordId } from '@/api/common/types';

export const statisticsQueryKeys = {
  all: ['statistics'] as const,
  contractStatistics: () => [...statisticsQueryKeys.all, 'contract'] as const,
  contractStatistic: (contractId: RecordId) =>
    [...statisticsQueryKeys.contractStatistics(), contractId] as const,
};
